export const TermsNotAgreedStatusCode = 451;
